import { ResponseDataType } from "@/models/types";
import { BaseClass } from "./base";
import { ActivityDto, ActivityInDto, ActivityTypeDto, ApplyCompanyDto, ConfigDto, InsuranceDto, MessageDto, StatCountDto, StatLineDto } from "@/models/dtos";
import { AuditActivityArgs, AuditApplyCompanyArgs, ChangeMessageStateArgs, CreateActivityArgs, CreateActivityTypeArgs, CreateConfigArgs, CreateInsuranceArgs, QueryActivityArgs, QueryActivityInArgs, QueryActivityTypeArgs, QueryApplyCompanyArgs, QueryInsuranceArgs, QueryMessageArgs, ReplyMessageArgs } from "@/models/args";

export class MessageClass extends BaseClass{
  gets(args: QueryMessageArgs){
    return this.get<ResponseDataType<MessageDto>>('/api/Message', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/Message/${id}`)
  }

  state(args: ChangeMessageStateArgs){
    return this.post<number>('/api/Message/ChangeState', args)
  }

  reply(args: ReplyMessageArgs){
    return this.post<number>('/api/Message/Reply', args)
  }
}

export class ApplyCompanyClass extends BaseClass{
  gets(args: QueryApplyCompanyArgs){
    return this.get<ResponseDataType<ApplyCompanyDto>>('/api/ApplyCompany', args)
  }

  audit(data: AuditApplyCompanyArgs){
    return this.post<number>('/api/ApplyCompany/Bind', data)
  }

  excel(args: QueryApplyCompanyArgs){
    return this.export('/api/ApplyCompany/Export','GET', args)
  }
}

export class ActivityInClass extends BaseClass {
  gets(args: QueryActivityInArgs){
    return this.get<ResponseDataType<ActivityInDto>>('/api/ActivityIn', args)
  }

  exports(args: QueryActivityInArgs){
    return this.export<Blob>('/api/ActivityIn/Export', 'GET', args)
  }
}

export class ActivityClass extends BaseClass {
  gets(args: QueryActivityArgs){
    return this.get<ResponseDataType<ActivityDto>>('/api/Activity', args)
  }

  detail(id: number){
    return this.get<ActivityDto>(`/api/Activity/${id}`)
  }

  create(args: CreateActivityArgs){
    return this.post<number>('/api/Activity', args)
  }

  update(args: CreateActivityArgs){
    return this.put<number>('/api/Activity', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/Activity/${id}`)
  }

  audit(args: AuditActivityArgs){
    return this.post<number>('/api/Activity/Audit', args)
  }

  hot(id: number, state: boolean){
    return this.get<number>(`/api/Activity/Hot/${id}/${state}`)
  }

  top(id: number, state: boolean){
    return this.get<number>(`/api/Activity/Top/${id}/${state}`)
  }

  show(id: number, state: boolean){
    return this.get<number>(`/api/Activity/Show/${id}/${state}`)
  }

  reset(id: number){
    return this.get<number>(`/api/Activity/ResetAudit/${id}`)
  }

  info(){
    return this.get<StatCountDto>('/api/Activity/StatInfo')
  }

  line(){
    return this.get<StatLineDto[]>('/api/Activity/StatLine')
  }
}

export class InsuranceClass extends BaseClass {
  gets(args: QueryInsuranceArgs){
    return this.get<ResponseDataType<InsuranceDto>>('/api/Insurance', args)
  }

  create(args: CreateInsuranceArgs){
    return this.post<number>('/api/Insurance', args)
  }

  update(args: CreateInsuranceArgs){
    return this.put<number>('/api/Insurance', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/Insurance/${id}`)
  }

  active(id: number, state: boolean){
    return this.delete<number>(`/api/Insurance/IsActive/${id}/${state}`)
  }
}

export class ConfigClass extends BaseClass {
  gets(){
    return this.get<ConfigDto[]>('/api/Config')
  }

  create(args: CreateConfigArgs){
    return this.post<number>('/api/Config', args)
  }

  update(args: ConfigDto[]){
    return this.put<number>('/api/Config', args)
  }
}

export class ActivityTypeClass extends BaseClass {
  gets(args: QueryActivityTypeArgs){
    return this.get<ResponseDataType<ActivityTypeDto>>('/api/ActivityType', args)
  }

  create(args: CreateActivityTypeArgs){
    return this.post<number>('/api/ActivityType', args)
  }

  update(args: CreateActivityTypeArgs){
    return this.put<number>('/api/ActivityType', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/ActivityType/${id}`)
  }

  show(id: number, state: boolean){
    return this.get<number>(`/api/ActivityType/Show/${id}/${state}`)
  }
}